import React from 'react'
import { Box, Slider, TextField, Typography } from '@mui/material'

const marks = [
  {
    value: 0,
    label: '0'
  },
  {
    value: 250,
    label: '250'
  },
  {
    value: 500,
    label: '500'
  }
]

interface SimsProps {
  simsQuantity: number | Array<number>
  setSimsQuantity: (value: number | Array<number>) => void
}

function ChooseSimQuantity({ simsQuantity, setSimsQuantity }: SimsProps) {
  const handleSimQuantity = (value: number | Array<number>): void => {
    if (value > 500) {
      setSimsQuantity(500)
    } else setSimsQuantity(value)
    //if invalid number is keyed in, default to 0
    if (isNaN(Number(value))) {
      setSimsQuantity(0)
    }
  }

  return (
    <>
      <Box sx={{ padding: '16px' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '8px'
          }}
        >
          <Typography
            variant='subtitle1'
            sx={{
              color: 'primary.dark',
              fontWeight: 500
            }}
          >
            Choose Number Of SIMS:
          </Typography>
          <TextField
            sx={{
              width: '3vw',
              '& .MuiInputBase-input': {
                textAlign: 'center'
              }
            }}
            inputProps={{ max: 500 }}
            data-cy='simsQuantityBox'
            value={simsQuantity}
            size='small'
            onChange={(e) => handleSimQuantity(Number(e.target.value))}
          />
        </Box>

        <Box sx={{ paddingLeft: '8px' }}>
          <Slider
            value={simsQuantity}
            data-cy='simsQuantitySlider'
            id='simsQuantity-slider'
            max={500}
            min={0}
            marks={marks}
            step={10}
            valueLabelDisplay='auto'
            onChange={(_, value) => handleSimQuantity(value)}
            sx={{
              '& .MuiSlider-track': {
                width: `${((Number(simsQuantity) / 500) * 100).toFixed(
                  0
                )}% !important`
              },
              '& .MuiSlider-thumb': {
                left: `${((Number(simsQuantity) / 500) * 100).toFixed(
                  0
                )}% !important`
              }
            }}
          />
        </Box>
      </Box>
    </>
  )
}

export default ChooseSimQuantity
